// @flow
import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useMediaQuery } from 'react-responsive';
import HorizontalCarousel from 'components/molecules/horizontalCarousel';
import IntroCard from 'components/molecules/introductionCard';
import { PaginationControl } from 'components/molecules/paginationControl';
import { useViewport } from 'components/templates/viewportProvider';
//eslint-disable-next-line
import styles from "./style.scss";

type Props = {
  theme: string,
};

const TestimonialPage = (props: Props) => {
  const { height } = useViewport();

  const isTablet = useMediaQuery({
    query: '(max-width: 1250px) and (min-width: 578px)',
  });
  const isMobile = useMediaQuery({
    query: '(max-width: 767px)',
  });

  const [sliderRef, setSlider] = useState(null);
  const [activeSlide, setActiveSlide] = useState(0);

  let { testimonialData, type } = props.data;
  const data = testimonialData;

  if (!data[0]) {
    return null;
  }

  const handleSliderRef = ref => {
    setSlider(ref);
  };

  const next = () => {
    sliderRef.slickNext();
  };

  const previous = () => {
    sliderRef.slickPrev();
  };

  const paginationSliderLength = () => {
    const dataItems =
      type === 'videos'
        ? data && data[0].videos
        : data && data[0].testimonial_clients;
    return dataItems ? (dataItems.length < 3 ? 1 : dataItems.length - 1) : '';
  };

  return (
    <div
      className={'testimonial-container section-container'}
      style={{ height }}
      id={type === 'videos' ? 'videos' : 'testimonials'}
    >
      <Row>
        <Col xs={{ span: 11 }} md={{ span: 4, offset: 0 }} className={'column'}>
          {data.map((item, idx) => (
            <IntroCard data={item} key={idx} />
          ))}
        </Col>
        <Col md={{ span: 8, offset: 0 }}>
          <div className={'slider'}>
            {!isMobile ? (
              data && data[0] ? (
                <HorizontalCarousel
                  data={data && data[0]}
                  mediaPath={data && data[0].media_path}
                  type={isTablet ? 'testimonialTablet' : 'testimonial'}
                  cssFor={'testimonial'}
                  getActiveSlide={e => {
                    setActiveSlide(e);
                  }}
                  handleSliderRef={handleSliderRef}
                  sectionType={type}
                />
              ) : null
            ) : data && data[0] ? (
              <HorizontalCarousel
                data={data && data[0]}
                mediaPath={data && data[0].media_path}
                type={'testimonialMobile'}
                cssFor={'Carousel_Testimonial'}
                sectionType={type}
              />
            ) : null}
          </div>
        </Col>
      </Row>
      {!isMobile ? (
        <div className={'section-footer'}>
          <PaginationControl
            className={'section-footer-item'}
            theme={'dark-theme'}
            mode={'slider'}
            currentIndex={activeSlide + 1}
            onNextClick={next}
            onPreviousClick={previous}
            total={paginationSliderLength()}
          />
        </div>
      ) : null}
    </div>
  );
};

export default TestimonialPage;
